module.exports = __webpack_public_path__ + "img/PROTON.6ef128d.jpg";